import { PostType } from 'pn-backend';

import { getPost, getPostPreview } from '~server';
import { config } from '~services';
import { Post } from '~templates';

export const getServerSideProps = config.IS_PREVIEW ? getPostPreview : getPost(PostType.NewsFull);

export default Post;
